import { useEffect } from "react"

export default function Blog() {
    useEffect(() =>{
        window.location.href = "https://blog.ketobalanced.com";
    },[])
  return (
    <div className="bg-custombgColor w-screen h-screen flex justify-center items-center">Loading...</div>
  )
}